import React from 'react';
import classNames from 'classnames';

import ColorBubble, {
  ClassesType as ColorBubbleClassesType,
} from 'components/Common/ColorBubble/ColorBubble';
import { getUri } from 'services/generic';

import styles from './ProductCardColors.module.scss';

type PropsType = {
  colors: ColorType[];
  nbDisplay: number;
  className?: string;
  classes?: ClassesType;
};
type ColorType = {
  color: string;
  image: string;
  url: string;
};
type ClassesType = {
  colorBubble?: ColorBubbleClassesType;
};

export default function ProductCardColors({
  colors,
  nbDisplay,
  className,
  classes,
}: PropsType): JSX.Element {
  const colorsDisplayed = colors.slice(0, nbDisplay);
  const nbHidden = colors.length - nbDisplay;

  return (
    <div className={classNames(styles.container, className)}>
      <ul>
        {colorsDisplayed.map(({ color, image, url }) => (
          <li key={color}>
            <ColorBubble
              classes={{
                container: classes?.colorBubble?.container,
                image: classNames(
                  styles.colorBubbleImage,
                  classes?.colorBubble?.image
                ),
              }}
              color={color}
              image={image}
              url={getUri(url)}
            />
          </li>
        ))}
      </ul>
      {nbHidden > 0 && <span className={styles.nbHidden}>{nbHidden}</span>}
    </div>
  );
}
